module.exports = __webpack_public_path__ + "media/images/Branding/HW Red 2-e17303afbaf2680e0719e3bba9a13ad6.png";